import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToInterval'
})
export class DateToIntervalPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let commentDate = new Date(value);
    let dateDiff = Math.abs(new Date(commentDate).getTime() - new Date().getTime());
    let diffinDays = Math.floor(dateDiff / (1000 * 3600 * 24));
    let commentDateDiff = "";
    if (diffinDays === 0) {
      commentDateDiff = "Today";
    } else {
      if (diffinDays < 30) {
        commentDateDiff = diffinDays + " day(s) ago";
      } else {
        if (diffinDays >= 30 && diffinDays < 365) {
          commentDateDiff = Math.floor(diffinDays / 30) + " month(s) ago";
        } else {
          commentDateDiff = Math.floor(diffinDays / 365) + " year(s) ago";
        }
      }
    }
    return commentDateDiff;
  }

}
